/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Languages_LabelInputs */

const en_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const fr_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues`)
};

const de_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen`)
};

const it_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingue`)
};

const ru_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Языки`)
};

const es_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas`)
};

const zh_cn2_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ja_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const hi_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बोली`)
};

const pt_pt2_knp_guide_languages_label = /** @type {(inputs: Knp_Guide_Languages_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Línguas`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Knp_Guide_Languages_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_languages_label = /** @type {((inputs?: Knp_Guide_Languages_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Languages_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_languages_label(inputs)
	if (locale === "de") return de_knp_guide_languages_label(inputs)
	if (locale === "it") return it_knp_guide_languages_label(inputs)
	if (locale === "ru") return ru_knp_guide_languages_label(inputs)
	if (locale === "es") return es_knp_guide_languages_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_languages_label(inputs)
	if (locale === "ja") return ja_knp_guide_languages_label(inputs)
	if (locale === "hi") return hi_knp_guide_languages_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_languages_label(inputs)
	return en_knp_guide_languages_label(inputs)
});